module.exports = __webpack_public_path__ + "img/娑罗子.f612397c.jpg";